/*
 * "Explore More Print" product block: a row that scrolls sideways - by the
 * arrows either side, which step one card at a time and disable at either
 * end, or by a trackpad or a swipe.
 *
 * Whether the arrows show at all is counted, not measured: more cards than
 * the row shows at once (--emp-per-view in the CSS) means there is somewhere
 * to go. A measurement taken while the row was hidden or still loading used
 * to read as "everything fits" and hide them for good.
 *
 * A custom element, so it wires itself up wherever the markup lands -
 * including the quick view, which fetches its content after load.
 */
(function () {
  if (customElements.get('explore-more-prints')) return;

  class ExploreMorePrints extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-emp-viewport]');
      this.track = this.querySelector('[data-emp-track]');
      this.prev = this.querySelector('[data-emp-prev]');
      this.next = this.querySelector('[data-emp-next]');
      if (!this.viewport || !this.track) return;

      this.update = this.update.bind(this);
      this.prev && this.prev.addEventListener('click', () => this.step(-1));
      this.next && this.next.addEventListener('click', () => this.step(1));
      this.viewport.addEventListener('scroll', this.update, { passive: true });

      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this.viewport);
      } else {
        window.addEventListener('resize', this.update);
      }
      window.addEventListener('load', this.update);
      this.update();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      window.removeEventListener('resize', this.update);
      window.removeEventListener('load', this.update);
    }

    get perView() {
      const carousel = this.querySelector('.emp__carousel') || this;
      const value = parseInt(getComputedStyle(carousel).getPropertyValue('--emp-per-view'), 10);
      return value > 0 ? value : 6;
    }

    // One card plus the gap after it.
    get cardStep() {
      const first = this.track.firstElementChild;
      if (!first) return 0;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      return first.getBoundingClientRect().width + gap;
    }

    step(direction) {
      const cardStep = this.cardStep;
      if (!cardStep) return;
      const current = Math.round(this.viewport.scrollLeft / cardStep);
      this.viewport.scrollTo({ left: (current + direction) * cardStep, behavior: 'smooth' });
    }

    update() {
      const hasMore = this.track.children.length > this.perView;
      this.classList.toggle('emp--static', !hasMore);

      const max = this.viewport.scrollWidth - this.viewport.clientWidth;
      const left = this.viewport.scrollLeft;
      if (this.prev) this.prev.disabled = !hasMore || left <= 1;
      // Not yet laid out (max is 0 while hidden) still leaves Next live, so
      // it works the moment the row is shown.
      if (this.next) this.next.disabled = !hasMore || (max > 0 && left >= max - 1);

      const media = this.track.querySelector('.emp__media');
      if (media && media.offsetHeight) {
        this.style.setProperty('--emp-arrow-top', media.offsetHeight / 2 + 'px');
      }
    }
  }

  customElements.define('explore-more-prints', ExploreMorePrints);
})();
